<template>
  <div>
    <com-search :columns="searchColumn" @search="search">
      <slot />
    </com-search>
  </div>
</template>

<script>
export default {
  props: {
    typeOfView: {
      type: String,
      default: ''
    }
  },
  watch: {
    typeOfView: {
      handler(val) {
        if (val !== 'site') {
          this.searchColumn.pop()
        }
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      searchColumn: [
        {
          label: '设备号',
          prop: 'sn',
          type: 'input'
        },
        {
          label: '二维码',
          prop: 'label',
          type: 'input'
        },
        {
          label: '绑定时间',
          prop: 'date',
          type: 'date'
        },
        {
          label: '设备状态',
          prop: 'deviceStatus',
          type: 'select',
          option: [
            {
              label: '在线',
              value: 1
            },
            {
              label: '离线',
              value: 2
            }
          ]
        }
      ]
    }
  },
  methods: {
    search(val) {
      this.$emit('search', val)
    }
  }
}
</script>

<style lang="scss" scoped></style>
